// extracted by mini-css-extract-plugin
export default {"prev-slide-btn":"PrevBtn_prev-slide-btn__SK1qk","prev-slide-btn__icon":"PrevBtn_prev-slide-btn__icon__gjmbv"};